import React from 'react';
import { useMood } from '../../../contexts/MoodContext';
import { getMood, MoodId } from '../moods';
import AnimatedMoodIllustration from '../visual/AnimatedMoodIllustration';
import FloatingParticleLayer from '../visual/FloatingParticleLayer';

/**
 * RelaxingVisual — a watch-only calming scene. Nothing to complete, nothing to
 * type: the mood's animated illustration drifts inside a soft glow with a few
 * floating particles, and a gentle line invites the person to simply rest their
 * eyes for a moment. Fully optional, easy to leave.
 *
 * `mood` can be passed explicitly (the Mood Journal does this, where there's no
 * session mood); otherwise it falls back to the session mood, and finally to a
 * calm default so the scene is never empty.
 */
export const RelaxingVisual: React.FC<{ mood?: MoodId }> = ({ mood: moodProp }) => {
  const { sessionMood } = useMood();
  const mood = getMood(moodProp ?? sessionMood) ?? getMood('calm');

  return (
    <div className="mm-relax">
      <div className="mm-relax__stage">
        <FloatingParticleLayer count={8} />
        <span className="mm-relax__glow" aria-hidden="true" />
        {mood && <AnimatedMoodIllustration mood={mood.id} size="lg" />}
      </div>
      <p className="mm-relax__line">Nothing to do here — just watch for a moment and let it settle.</p>
    </div>
  );
};

export default RelaxingVisual;
